import { render, staticRenderFns } from "./inputRating.vue?vue&type=template&id=5fef0352&"
import script from "./inputRating.vue?vue&type=script&lang=js&"
export * from "./inputRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports